module.exports = __webpack_public_path__ + "img/1747704930925-image.jpg.70b34bc7.webp";